import { AccordionDetails, Box, Button } from "@mui/material";
import React, { Suspense, useEffect, useState } from "react";
import styled from "styled-components";
import ImageComponent from "../ImageComponent";
import ButtonDropDown from "../../../ButtonDropDown";

const DetailsDiv = styled(AccordionDetails)(({ theme }) => ({
  background: "#fff",
  "& img": {
    height: "50px",
    width: "50px",
    objectFit: "contain",
    borderRadius: "5px",
  },
  "& p": {
    margin: "0",
    marginTop: "10px",
    marginBottom: "0",
  },
  "& small": {
    color: "grey",
    fontSize: "12px",
    lineHeight: "1.4",
  },
}));

const OrderDetails = ({ handlePickupOrder, handleUnpickOrder, handleViewHistoryDetails, handlePrint, handleMarkPick, handleResendInvoice, fulfilled, fulfill, order, markPick, print }) => {

  const handleClickPrint = (val, row) => {
    handlePrint(val, row);
  };

  return (
    <div>
      <DetailsDiv>
        {print ? order?.sales_lines?.map((sales, index) => {
          return (
            <Box
              display={"grid"}
              gridTemplateColumns={"1fr 3fr 0.5fr 1fr"}
              alignItems={"center"}
              gap="10px"
              key={sales.id}
              mb={1}
            >
              <div>
                <Suspense>
                  <ImageComponent
                    imageUrl={sales?.line_details?.ax_details?.imageUrl}
                    alt={`sales-${sales.id}`}
                  />
                </Suspense>
              </div>
              <div>
                <p>{sales?.itemname}</p>
                <div style={{ lineHeight: "1.0" }}>
                  <small>Colour: {sales?.line_details?.ax_details?.ColourName}</small>
                  <br />
                  <small>Size: {sales?.line_details?.ax_details?.SizeID}</small>
                </div>
              </div>
              <div>
                <p>{fulfill ? parseInt(sales?.quantity) : parseInt(sales?.quantity)}</p>
              </div>
              <div>{sales?.line_details?.lineamount === null ? "" : `$${parseFloat(sales?.line_details?.lineamount).toFixed(2)}`}</div>

            </Box>
          );
        }) : order?.sales_lines?.map((sales, index) => {
          return (
            <Box
              display={"grid"}
              gridTemplateColumns={"1fr 3fr 0.5fr 1fr"}
              alignItems={"center"}
              gap="10px"
              key={sales.id}
              mb={1}
            >
              <div>
                <Suspense>
                  <ImageComponent
                    imageUrl={sales?.ax_details?.imageUrl}
                    alt={`sales-${sales.id}`}
                  />
                </Suspense>
              </div>
              <div>
                <p>{sales?.itemname}</p>
                <div style={{ lineHeight: "1.0" }}>
                  <small>Colour: {sales?.ax_details?.ColourName}</small>
                  <br />
                  <small>Size: {sales?.ax_details?.SizeID}</small>
                </div>
              </div>
              <div>
                {/* <p>{fulfill ? parseInt(sales?.totalFulfilledQty) : parseInt(sales?.actual_total_lines) - parseInt(sales?.totalFulfilledQty)}</p> */}
                <p>{fulfill ? parseInt(sales?.totalFulfilledQty) : parseInt(sales?.quantity)}</p>
              </div>
              <div>{sales?.lineamount === null ? "" : `$${parseFloat(sales?.lineamount).toFixed(2)}`}</div>

            </Box>
          );
        })}
        <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
          style={{ borderTop: "1px solid #999" }}
          pt={2}
          gap={"15px"}
        >
          {handlePrint ? (
            <>
              <Button
                variant="contained"
                color="primary"
                onClick={() => handlePrint("Print", order)}
                style={{ marginRight: "10px" }}
              >
                Pickup Slip
              </Button>

              <Button
                variant="contained"
                color="primary"
                onClick={() => handlePrint("Print A4", order)}
                style={{ marginRight: "10px" }}
              >
                Pickup A4 Slip
              </Button>
            </>
          ) : (
            ""
          )}

          {markPick ? (
            <Button
              variant="contained"
              color="secondary"
              onClick={() => handleMarkPick(order)}
            >
              Mark as Picked
            </Button>
          ) : ""}

          {handleUnpickOrder ? (
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleUnpickOrder(order)}
            >
              Unpick Order
            </Button>
          ) : ""}

          {handlePickupOrder ? (
            // && !markPick && !fulfilled 
            <Button
              variant="contained"
              color="secondary"
              onClick={() => handlePickupOrder(order)}
            >
              Pickup Order
            </Button>
          ) : (
            ""
          )}


          {handleViewHistoryDetails ? (
            // && !markPick && !fulfilled 
            <Button
              variant="contained"
              color="secondary"
              onClick={() => handleViewHistoryDetails(order)}
            >
              Query History
            </Button>
          ) : (
            ""
          )}

          {handleResendInvoice ? (
            // && !markPick && !fulfilled 
            <Button
              variant="contained"
              color="secondary"
              onClick={() => handleResendInvoice(order)}
            >
              Resend Tax Invoice
            </Button>
          ) : (
            ""
          )}
        </Box>
      </DetailsDiv>
    </div>
  );
};

export default OrderDetails;
